import Vue from 'vue'
import Router from 'vue-router'
let router = new Router({
	routes: [{
			path: '/',
			name: 'home',
			redirect: '/index',
			component: () => import('../views/Home.vue'),
			children: [{
					path: 'queryn',
					name: 'queryn',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/Queryn.vue'),
				},
				{
					path: 'index',
					name: 'index',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/index.vue'),
				},
				{
					path: 'query',
					name: 'query',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/Query.vue'),
				},
				{
					path: 'shop',
					name: 'shop',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/shop.vue'),
				},
				{
					path: 'shopdetails',
					name: 'shopdetails',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/shopdetails.vue'),
				},
				{
					path: 'send',
					name: 'send',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/Send.vue'),
				},
				{
					path: 'us',
					name: 'us',
					meta: {
						keepAlive: true
					},
					component: () => import('../views/Us.vue'),
				},
				{
					path: 'buy',
					name: 'buy',
					meta: {
						keepAlive: true
					},
					component: () => import('../views/buy.vue'),
				},
				{
					path: 'login',
					name: 'login',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/Login.vue'),
				},
				{
					path: 'xianggang',
					name: 'xianggang',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/xianggang.vue'),
				},
				{
					path: 'zhongguo',
					name: 'zhongguo',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/zhongguo.vue'),
				},
				{
					path: 'jingnei',
					name: 'jingnei',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/jingnei.vue'),
				},
				{
					path: 'reg',
					name: 'reg',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/Register.vue'),
				},
				{
					path: 'Home',
					name: 'Home',
					meta: {
						keepAlive: false
					},
					component: () => import('../views/Home.vue'),
				},
				{
					path: "pcupload",
					name: "pcupload",
					component: () => import('../views/PcUpload.vue')
				},

			]
		},
		{
			path: "/express",
			name: "express",
			component: () => import('../views/Express.vue')
		},
		{
			path: "/expressnew",
			name: "expressnew",
			component: () => import('../views/Expressnew.vue')
		},
		{
			path: "/qrcode",
			name: "qrcode",
			meta: {
				nopeach: true
			},
			component: () =>
				import('../views/Qrcode.vue'),
		},
		{
			path: "/code",
			name: "code",
			meta: {
				nopeach: true
			},
			component: () =>
				import('../views/Code.vue')
		},
		{
			path: "/code1",
			name: "code1",
			meta: {
				nopeach: true
			},
			component: () =>
				import('../views/Code1.vue')
		},
		{
			path: "/upload",
			name: "upload",
			component: () =>
				import('../views/Upload.vue')
		},
		{
			path: '/mobile',
			name: 'mobile',
			component: () => import('../mviews/Home.vue'),
			meta: {
				keepAlive: false
			},
			redirect: '/mindex',
			children: [{
					path: '/mindex',
					name: 'mindex',
					meta: {
						keepAlive: false
					},
					component: () => import('../mviews/index.vue'),
				},
				{
					path: '/mindex',
					name: 'mindex',
					meta: {
						keepAlive: false
					},
					component: () => import('../mviews/index.vue'),
				},
				{
					path: '/mqueryn',
					name: 'mqueryn',
					meta: {
						keepAlive: false
					},
					component: () => import('../mviews/Queryn.vue'),
				},
				{
					path: '/mquery',
					name: 'mquery',
					meta: {
						keepAlive: false
					},
					component: () => import('../mviews/Query.vue'),
				},
				{
					path: '/msend',
					name: 'msend',
					meta: {
						keepAlive: false,
					},
					component: () => import('../mviews/Send.vue'),
				},
				{
					path: '/mrepair',
					name: 'mrepair',
					meta: {
						keepAlive: true,
						isLogin: false,
					},
					component: () => import('../mviews/Repair.vue'),
				},
				{
					path: '/mshop',
					name: 'mshop',
					meta: {
						keepAlive: true,
						isLogin: false,
					},
					component: () => import('../mviews/shop.vue'),
				},
				{
					path: '/mcart',
					name: 'mcart',
					meta: {
						keepAlive: true,
						isLogin: false,
					},
					component: () => import('../mviews/cart.vue'),
				},
				{
					path: '/mdetails',
					name: 'mdetails',
					meta: {
						keepAlive: true,
						isLogin: false,
					},
					component: () => import('../mviews/details.vue'),
				},
				{
					path: '/muser',
					name: 'muser',
					meta: {
						keepAlive: true,
						isLogin: true,
					},
					component: () => import('../mviews/User.vue'),
				},
				{
					path: '/mconnect',
					name: 'mconnect',
					meta: {
						keepAlive: false
					},
					component: () => import('../mviews/Connect.vue'),
				},
			]
		},
		{
			path: '/mlogin',
			name: 'mLogin',
			component: () => import('../mviews/Login.vue'),
			meta: {
				title: '登录'
			}
		},
		{
			path: '/mregister',
			name: 'mRegister',
			component: () => import('../mviews/Register.vue'),
			meta: {
				title: '注册'
			}
		},

	],

});
router.beforeEach((to, from, next) => {
	if (to.meta.nopeach) {
		localStorage.setItem('code', 1)
	} else {
		localStorage.setItem('code', 0)
	}
	if (to.meta.isLogin) {
		if (window.sessionStorage.uid) {
			next();
		} else {
			next("/mlogin");
		}
	}
	next();
})

export default router;

Vue.use(Router)



// WEBPACK FOOTER //
// ./src/router/index.js